import React from "react";
import { ReactComponent as Logo } from "../assets/logo.svg";

const Header = () => {
  return (
    <header className="flex flex-col">
      <div className="text-center flex flex-row items-center justify-center gap-20 bg-header-bg bg-repeat pt-4">
        <Logo className="pb-4" />
        <span className="text-4xl text-eithnary w-1/3">
          Sustentabilidade é uma pendência, e não uma tendência.
        </span>
      </div>
      <span className="bg-quinary h-[4px] w-full flex"></span>
    </header>
  );
};

export default Header;
